<template>
  <div>
    <date-time-filter v-model="dtRange" class="mb-3" />
    <transition name="slide-fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import DateTimeFilter from '@/components/utils/DateTimeFilter';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'LoggingView',
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Grafy / Logování',
        },
      ],
    };
  },
  computed: {
    ...mapState('app', [
      'logging',
    ]),
    dtRange: {
      get() {
        return [this.logging.selectedDtRange.from, this.logging.selectedDtRange.to];
      },
      set(value) {
        this.setState({
          section: 'logging',
          setting: { selectedDtRange: { from: value[0], to: value[1] } },
        });
      },
    },
  },
  methods: {
    ...mapActions('app', [
      'setState',
    ]),
  },
  mixins: [
    BreadcrumbsManager,
  ],
  components: {
    DateTimeFilter,
  },
};
</script>

<style scoped>
.slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(10px);
    opacity: 0;
  }
</style>
